export function noticetoConsumersConfidentialInformation() {
return [   // Release 2026-10-12 13:20:32
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Client 1 Name Legal", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 534.4,
   left: 151.398,
   width: 395.282,
   height: 14.127
}
,
{
   page: 0,
   name: "Client 2 Name Legal", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 597.64,
   left: 151.398,
   width: 395.282,
   height: 14.127
}
,
{
   page: 0,
   name: "Client 3 Name Legal", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 661.0,
   left: 151.398,
   width: 395.282,
   height: 14.127
}
,
{
   page: 1,
   name: "Agent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 111.076,
   left: 71.1378,
   width: 334.6922,
   height: 15.513
}
,
{
   page: 1,
   name: "Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 156.305,
   left: 426.36,
   width: 126.12,
   height: 44.313
}
,
{
   page: 1,
   name: "Check Box1", 
   isText: false,
   type: "checkbox",
   top: 159.055,
   left: 121.091,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box2", 
   isText: false,
   type: "checkbox",
   top: 159.055,
   left: 194.401,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box3", 
   isText: false,
   type: "checkbox",
   top: 159.055,
   left: 252.656,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Check Box4", 
   isText: false,
   type: "checkbox",
   top: 159.055,
   left: 379.638,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Signature Agent Initials", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 181.964,
   left: 147.273,
   width: 46.582,
   height: 16.764
}
,
{
   page: 1,
   name: "Date Delivered", 
   fontSize: 9,
   type: "date",
   top: 111.076,
   left: 420.875,
   width: 106.145,
   height: 15.513
}
] }
